export default __webpack_public_path__ + "static/media/img3pro9.23cb316b.jpeg";